import { useState } from "react";
import { useSelector } from "react-redux";
import Papa from "papaparse";

import { RootState } from "../../store/store";
import { csvKeys } from "../../config/CsvKeys";
import { ShotExtra } from "../../store/Session/SessionModel";
import {
  generateClubGroup,
  getFormattedClubName
} from "../../store/Session/helper/GenerateClubGroup";

import "./style.css";

const Csv = (): JSX.Element => {
  const sessionData = useSelector((state: RootState) => state.session);

  const [isFading, setIsFading] = useState(false);
  const transformDataDrillTarget = () => {
    let drillTargets = sessionData.drillTargets?.map((target: any) => {
      let newTarget = { ...target };
      newTarget["targetName"] = target.distance.maxDistance
        ? "Tee"
        : `${target.distance.distance}y`;
      newTarget["targetQuality"] = target.targetQuality?.toFixed() ?? "---";
      return newTarget;
    });
    return drillTargets;
  };
  const generateCsv = () => {
    setIsFading(true);
    let clubs = generateClubGroup(
      sessionData.shots,
      false,
      sessionData.measuringSystem,
      [],
      sessionData.location
    );
    const flatShots: any = clubs.flatMap((club) => club.shots);
    let drillTargets = transformDataDrillTarget();

    let csvJson = flatShots.map((shot: any) => {
      shot.clubName = getFormattedClubName(shot.clubName);
      shot.shotQuality = shot?.shotQuality?.toFixed();
      let target = drillTargets?.find(
        (target: any) => target.id === shot.lmDrillTargetId
      );
      shot["sessionQuality"] = sessionData.sessionQuality?.toFixed() ?? "---";
      shot["target"] = target;
      let objectToReturn: any = {};
      csvKeys[sessionData.measuringSystem].forEach(
        (keyObject: { title: string; key: string }) => {
          objectToReturn[keyObject.title] = keyObject.key
            .split(".")
            .reduce(
              (obj, key) =>
                obj && obj[key as keyof ShotExtra] !== undefined
                  ? obj[key as keyof ShotExtra]
                  : undefined,
              shot
            );
        }
      );

      return objectToReturn;
    });
    // Convert JSON to CSV
    const csvData = Papa.unparse(csvJson);

    var universalBOM = "\uFEFF";
    var a = window.document.createElement("a");
    a.setAttribute(
      "href",
      "data:text/csv; charset=utf-8," +
        encodeURIComponent(universalBOM + csvData)
    );
    a.setAttribute(
      "download",
      sessionData.name && sessionData.name.length
        ? `${sessionData.name}.csv`
        : `${sessionData.location}_${sessionData.measuringSystem}.csv`
    );
    window.document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      setIsFading(false);
    }, 200);
  };

  return (
    <div
      className={`${isFading ? "fade-out" : ""}`}
      onClick={() => generateCsv()}
    >
      <img
        className="icon-export-excel"
        src="/img/fs_csv.svg"
        alt="Export to Excel"
      />
    </div>
  );
};

export default Csv;
